import React from "react";

function SocialLinks() {
  return (
    <div className="group birinit">
      <h6>Social Sites </h6>
      <div className="social text-start">
        <a href="javascript:void(0)">
          <i className="fab fa-facebook-f"></i>
        </a>
        <a href="javascript:void(0)">
          <i className="fab fa-twitter"></i>
        </a>
        <a href="javascript:void(0)">
          <i className="fab fa-instagram"></i>
        </a>
        <a href="javascript:void(0)">
          <i className="fab fa-linkedin-in"></i>
        </a>
      </div>
    </div>
  );
}

export default SocialLinks;
